import { Dispatch } from 'redux';
import { RestApi } from '../../services/restapi.service'
import { ActionType, LayerName, ActionLoadMainConfig, HttpState, ActionRequestState, MainConfigResponseBody, ActionChangeLayerField} from '../../util/model';

export const actionLoadUserConfig = () => async (dispatch: Dispatch) => {
    const res = await RestApi.getConfig();
    const action: ActionLoadMainConfig = {
        type: ActionType.LOAD_ME_CONFIG,
        payload: res.data
    }
    dispatch(action as any);
}

export const actionUpdateConfig = (body: MainConfigResponseBody) => async (dispatch: Dispatch) => {
    try {
        const progress: ActionRequestState = {
            type: ActionType.REQUEST_USER_CONFIG_STATE,
            payload: HttpState.Progress
        }
        dispatch(progress as any)
        await RestApi.updateConfig(body);
        const success: ActionRequestState = {
            type: ActionType.REQUEST_USER_CONFIG_STATE,
            payload: HttpState.Success
        }
        dispatch(success as any)
    } catch (error) {
        console.log('error', error);
        const failure: ActionRequestState = {
            type: ActionType.REQUEST_USER_CONFIG_STATE,
            payload: HttpState.Failure
        }
        dispatch(failure as any)
    }
}

export const actionChangeLayerField = (layerName: LayerName, fieldKey: string, fieldValue: any): ActionChangeLayerField => ({
    type: ActionType.CHANGE_LAYER_FIELD,
    payload: {
        layerName,
        fieldKey,
        fieldValue
    }
})

export const actionUpdateConfigWithChange = (layerName: LayerName, fieldKey: string, fieldValue: any, body: MainConfigResponseBody) => async (dispatch: Dispatch) => {
    try {
        const layer = body[layerName];
        body = {
            ...body,
            [layerName]: {
                ...layer,
                [fieldKey]: fieldValue
            }
        };
        const progress: ActionRequestState = {
            type: ActionType.REQUEST_USER_CONFIG_STATE,
            payload: HttpState.Progress
        }
        dispatch(progress as any)
        await RestApi.updateConfig(body);
        const success: ActionRequestState = {
            type: ActionType.REQUEST_USER_CONFIG_STATE,
            payload: HttpState.Success
        }
        dispatch(success as any)
    } catch (error) {
        console.log('error', error);
        const failure: ActionRequestState = {
            type: ActionType.REQUEST_USER_CONFIG_STATE,
            payload: HttpState.Failure
        }
        dispatch(failure as any)
    }
}
